export enum ExploreFilter {
  DEFAULT = "DEFAULT",
  BENCHMARK = "BENCHMARK",
  BOX = "BOX",
  PROGRAM = "PROGRAM",
  PROGRAM_BUNDLE = "PROGRAM_BUNDLE",
  PROFILE = "USER_PROFILE",
  PROGRAM_PRO = "PROGRAM_PRO",
}
